import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import Layout from '../components/Layout';
import Header from '../components/Header';
import Slices from '../components/Slices';
import Seo from '../components/Seo';

interface HomePageProps {
  data: any;
};

const HomePage: FC<HomePageProps> = ({ data }) => {
  const headerData = data.prismicHomepage?.data;

  return (
    <Layout>
      <Header data={headerData} />
      <Slices slices={data.prismicHomepage?.data?.body} />
    </Layout>
  )
};



export const query = graphql`
  query HomePage($id: String) {
    prismicNavigation {
      ...NavQuery
    }
    prismicHomepage(id: { eq: $id }) {
      _previewable
      ...Header
      ...AboutSection
      ...ProductCarousel
      ...ScienceSection
      ...EditorialReview
      ...FullScreenVideo
    }
  }
`;

export const Head = () => <Seo/>;

export default withPrismicPreview(HomePage);
